<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用工场景</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <!-- <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">用工场景</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item>
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto;"
                  >
                    <el-option label="上架" value="0"></el-option>
                    <el-option label="下架" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card> -->
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add('ruleForm')"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="title" label="场景名称" align="center">
          </el-table-column>
          <el-table-column prop="subTitle" label="场景描述" align="center">
          </el-table-column>
          <el-table-column prop="icon" label="场景ICON" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.icon"
                style="width: 40px; height: 40px; border-radius: 4px"
              />
            </template>
          </el-table-column>
          <el-table-column label="场景号码" align="center" prop="propValue">
          </el-table-column>
          <el-table-column label="排序" align="center" prop="sort">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="发布时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="显示" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.display == 0">否</span>
              <span class="greenColor" v-if="scope.row.display == 1">是</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination> -->
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="场景名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入场景名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="场景说明" prop="title">
          <el-input
            v-model="ruleForm1.title"
            placeholder="请输入场景名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="场景号码" prop="num">
          <el-input
            type="number"
            v-model="ruleForm1.num"
            placeholder="请输入场景号码"
            @input="handleInputNumber1"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            type="number"
            v-model="ruleForm1.sort"
            placeholder="请输入排序"
            @input="handleInputNumber"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否对外显示"
          prop="status"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.status">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="场景图标" prop="url">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="deader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            accept="image/*"
          >
            <img
              v-if="ruleForm1.url"
              :src="ruleForm1.url"
              class="avatar"
              style="width: 40px; height: 40px"
            />
            <div class="modelView1" v-if="ruleForm1.url">编辑</div>
            <i class="el-icon-plus" v-else></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axiosUrl from "../../api/axios.js";
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: "",
      ruleForm1: {
        sort: "",
        num: "",
        status: "",
        name: "",
        url: "",
        title: "",
      },
      rules: {
        sort: [{ required: true, message: "必填项", trigger: "blur" }],
        num: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        title: [{ required: true, message: "必填项", trigger: "blur" }],
        status: [{ required: true, message: "必选项", trigger: "blur" }],
        url: [{ required: true, message: "必选项", trigger: "change" }],
      },
      selectData: {},
      uploadUrl: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
    };
  },
  mounted() {
    this.getList();
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.ruleForm1.url = res.data;
    },
    handleInputNumber(value) {
      // 只允许数字，且最多6位
      this.ruleForm1.sort = value.replace(/\D/g, "").slice(0, 6);
    },
    handleInputNumber1(value) {
      // 只允许数字，且最多6位
      this.ruleForm1.num = value.replace(/\D/g, "").slice(0, 6);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            display: this.ruleForm1.status,
            title: this.ruleForm1.name,
            subTitle: this.ruleForm1.title,
            icon: this.ruleForm1.url,
            propValue: this.ruleForm1.num,
            sort: this.ruleForm1.sort,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/employscene/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.selectData = {};
                this.ruleForm1.num = "";
                this.ruleForm1.status = "";
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
                this.ruleForm1.url = "";
                this.ruleForm1.title = "";
              });
          } else {
            this.$axios
              .post(`admapi/employscene/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.selectData = {};
                this.ruleForm1.num = "";
                this.ruleForm1.status = "";
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
                this.ruleForm1.url = "";
                this.ruleForm1.title = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.title = "新增标签";
      this.dialogFormVisible = true;
      this.ruleForm1.num = "";
      this.ruleForm1.status = "";
      this.ruleForm1.sort = "";
      this.ruleForm1.name = "";
      this.ruleForm1.url = "";
      this.ruleForm1.title = "";
      this.selectData = {};
      this.editId = "";
      this.$refs.ruleForm.clearValidate();
    },
    handleEdit(val) {
      this.selectData = val;
      this.editId = val.id;
      this.title = "编辑标签";
      this.ruleForm1.sort = val.sort;
      this.ruleForm1.num = val.propValue;
      this.ruleForm1.name = val.title;
      this.ruleForm1.status = val.display;
      this.ruleForm1.url = val.icon;
      this.ruleForm1.title = val.subTitle;
      this.dialogFormVisible = true;
      this.$refs.ruleForm.clearValidate();
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.sort = "";
      this.ruleForm.num = "";
      this.ruleForm.url = "";
      this.ruleForm.title = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      this.$axios
        .post(`/admapi/employscene/list`)
        .then(({ data }) => {
          this.tableData = data;
          // this.tableData = data.items;
          // this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/employscene/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
